<template>
  <BaseModal 
    :model-value="modelValue" 
    @update:model-value="$emit('update:modelValue', $event)"
    title="Задать вопрос"
  >
    <div class="space-y-4">
      <div class="bg-[#242527] p-6 rounded-xl text-center">
        <p class="text-gray-300 text-lg mb-6">
          Если вам нужна помощь, вот наш email: <a href="mailto:info@carddy.ru" class="text-blue-400 hover:underline">info@carddy.ru</a>
        </p>
        
<!--        <a -->
<!--          href="https://t.me/carddy_bot" -->
<!--          target="_blank" -->
<!--          rel="noopener noreferrer" -->
<!--          class="bg-[#0088cc] text-white px-8 py-3 rounded-full font-medium inline-flex items-center hover:bg-[#0099dd] transition-colors"-->
<!--        >-->
<!--          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="currentColor">-->
<!--            <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.248-1.97 9.269c-.145.658-.537.818-1.084.51l-3-2.21-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.334-.373-.121L8.48 13.037l-2.95-.924c-.642-.203-.657-.642.137-.953l11.52-4.44c.532-.196.998.121.814.83z"/>-->
<!--          </svg>-->
<!--          Открыть Telegram бота-->
<!--        </a>-->
      </div>
    </div>
    
    <div class="mt-6 flex justify-end">
      <button 
        type="button" 
        @click="$emit('update:modelValue', false)" 
        class="px-4 py-2 rounded-full border border-gray-600 text-white hover:border-white transition-colors"
      >
        Закрыть
      </button>
    </div>
  </BaseModal>
</template>

<script>
import { defineComponent } from 'vue'
import BaseModal from './BaseModal.vue'

export default defineComponent({
  name: 'AskQuestionModal',
  components: {
    BaseModal
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue']
})
</script>
